import React, { useState, useEffect } from 'react'
import { KnovaText } from '../../BasicUIComponents/KnovaText'
import SCVideoComponent from '../../SCInteractComponents/SCVideoComponent'

function LayoutVideoDesc(props) {
  const {
    layoutData,
    themeProperties,
    isSideMenu,
    onVideoControlChange,
    isAudioPlaying,
    isPageChanged
  } = props
  const [textData, setTextData] = useState({})
  const [videoComponentData, setVideoComponentData] = useState({})

  useEffect(() => {
    let textDataCopy = layoutData.filter((e) => e.PluginId === 'SCTextArea')
    let videoComponentDataCopy = layoutData.filter(
      (e) => e.PluginId !== 'SCTextArea'
    )
    setTextData(textDataCopy[0])
    setVideoComponentData(videoComponentDataCopy[0])
  }, [])

  return (
    <div className='layout-main-cont'>
      <div
        className='layout-block-cont'
        style={{
          padding: '5px',
          pointerEvents:
            isAudioPlaying || isSideMenu || isPageChanged ? 'none' : 'auto'
        }}
      >
        <SCVideoComponent
          componentData={videoComponentData}
          themeColors={themeProperties.themeColors}
          themeFont={themeProperties.themeFont}
          onVideoControlChange={onVideoControlChange}
        />
      </div>
      <div className='layout-ques-cont' style={{ padding: '2% 2% 2% 2%' }}>
        <KnovaText
          text={textData.Value}
          textColor={themeProperties.themeColors.onBackground}
          textFontSize={isSideMenu ? '5px' : '16px'}
          textFontFamily={themeProperties.themeFont.bodyFont}
          textFontWeight='400'
          textHeight='150%'
        />
      </div>
    </div>
  )
}
export default LayoutVideoDesc
